// 좌측 내비(TheLeftBar) + 카테고리 허브 페이지(CategoryHubPage) 공용 메뉴 구조 (단일 소스).
//  - 리프:     { titleKey|title, icon, to }
//  - 카테고리: { titleKey|title, icon, to, subCategories: [ ...리프 ] }
//      · to가 비어있지 않으면(예 "/world") 헤더 클릭 시 그 허브 페이지로 이동.
//      · to가 ""이면 헤더는 클릭 불가(아직 허브 페이지 없음).
//  - title은 i18n 키(titleKey) 또는 리터럴(title, 비번역 dev 항목).
//  - localOnly: 로컬 환경에서만 노출.
//  - icon: "mdi-*"(v-icon) | "chzzk"(v-chzzk-icon) | 그 외 커스텀명(v-custom-icon).
export const NAV_CATEGORIES = [
  { titleKey: "nav.home", icon: "house_6018324", to: "/home" },
  {
    // (임시) 구 '방송' 카테고리를 '내 버츄펫' 이름/아이콘으로 사용 + 훈련/친밀도 편입
    titleKey: "nav.myVirtupet",
    icon: "pets",
    to: "/broadcast", // 허브 페이지 (헤더 클릭 시 카드 목록)
    subCategories: [
      {
        titleKey: "nav.broadcast",
        icon: "mic_5972696",
        to: "/my/broadcast",
        descKey: "categoryHub.desc.broadcast",
      },
      // 일단 방송게임 가림처리 (사이드바 + 허브 페이지 둘 다 숨겨짐)
      // {
      //   titleKey: "nav.broadcastGame",
      //   icon: "puzzle-game_4456836",
      //   to: "/broadcast/game",
      //   descKey: "categoryHub.desc.broadcastGame",
      // },
      // 플랫폼 연동은 방송하기(/my/broadcast) 최상단으로 편입 → 별도 메뉴 숨김
      // {
      //   titleKey: "nav.broadcastManage",
      //   icon: "business",
      //   to: "/broadcast/setting",
      //   descKey: "categoryHub.desc.broadcastManage",
      // },
      { titleKey: "nav.training", icon: "whistle", to: "/pet/training", descKey: "categoryHub.desc.training" },
      { titleKey: "nav.motion", icon: "motion", to: "/my/pet/reaction", descKey: "categoryHub.desc.motion" },
      // hubOnly(sub): 사이드바엔 숨기고 허브 페이지 구분선 아래에만 노출
      {
        titleKey: "nav.petSelect",
        icon: "mdi-select-group",
        to: "/pet/select",
        descKey: "categoryHub.desc.petSelect",
        hubOnly: true,
      },
      // hubOnly(sub): 사이드바엔 숨기고 허브 페이지 구분선 아래에만 노출
      {
        titleKey: "nav.petSetting",
        icon: "animal-shelter",
        to: "/pet/setting",
        descKey: "categoryHub.desc.petSetting",
        hubOnly: true,
      },
      {
        titleKey: "nav.myItems",
        icon: "backpack",
        to: "/my/items",
        descKey: "categoryHub.desc.myItems",
        hubOnly: true,
      },
    ],
  },
  {
    titleKey: "nav.world",
    icon: "world-animal-day",
    to: "/world", // ← 허브 페이지 있음 (헤더 클릭 시 카드 목록)
    showBalance: true, // 허브 헤더에 당근 잔액 배지 표시
    hubOnly: true, // 사이드 메뉴엔 서브 숨기고 /world 헤더 한 항목만 노출(서브는 허브 카드로만)
    subCategories: [
      { titleKey: "nav.petStore", icon: "in-store", to: "/pet/store", descKey: "categoryHub.desc.petStore" },
      { titleKey: "nav.hospital", icon: "hospital", to: "/pet/hospital", descKey: "categoryHub.desc.hospital" },
      { titleKey: "nav.gather", icon: "carrot", to: "/currency/gather", descKey: "categoryHub.desc.gather" },
    ],
  },
  {
    titleKey: "nav.sns",
    icon: "social-media",
    to: "/social", // 허브 페이지 (헤더 클릭 시 카드 목록)
    hubOnly: true, // 사이드 메뉴엔 서브 숨기고 /social 한 항목만 노출(서브는 허브 카드로만)
    subCategories: [
      {
        titleKey: "nav.socialBroadcast",
        icon: "broadcast_11574267",
        to: "/social/broadcast",
        descKey: "categoryHub.desc.socialBroadcast",
      },
      {
        titleKey: "nav.shortForm",
        icon: "short-video",
        to: "/social/short-form",
        descKey: "categoryHub.desc.shortForm",
      },
      {
        titleKey: "nav.lifeFourCut",
        icon: "mdi-camera",
        to: "/social/life-four-cut",
        descKey: "categoryHub.desc.lifeFourCut",
      },
      { titleKey: "nav.ranking", icon: "top-three", to: "/pet/ranking", descKey: "categoryHub.desc.ranking" },
    ],
  },
  { titleKey: "nav.settings", icon: "setting_12549859", to: "/user/setting" },
  {
    title: "Local",
    icon: "flask_8194481",
    to: "",
    localOnly: true,
    subCategories: [
      { title: "사이트맵", icon: "flask_8194481", to: "/temp", localOnly: true },
      { title: "MOD DEV", icon: "puzzle-game_4456836", to: "/mod-dev", localOnly: true },
      { title: "뇌구조 데모", icon: "flask_8194481", to: "/lab/brain", localOnly: true },
    ],
  },
];

// 팬 공간 전용 사이드바 메뉴 (스트리머 NAV_CATEGORIES와 완전 분리). 리프만: { title, icon(mdi-*), to }
export const FAN_NAV_CATEGORIES = [
  { title: "팬 홈", icon: "mdi-home-heart", to: "/fan" },
  { title: "추천 방송", icon: "mdi-television-play", to: "/fan/recommend" },
  { title: "펫 검색", icon: "mdi-magnify", to: "/fan/pet-search" },
  { title: "내가 만든 리액션", icon: "mdi-emoticon-outline", to: "/fan/reactions" },
  { title: "리액션 만들기", icon: "mdi-plus-circle", to: "/reaction/editor" },
];

export default NAV_CATEGORIES;
